import { Box, Typography, makeStyles } from '@material-ui/core'

import { useEffect, useState } from 'react'

import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import { Modal } from 'asterX-UI/Modals'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import Dot from 'asterX-UI/Icons/Dot'

import HeaderBack from 'components/Mobile/HeaderBack'
import { PageContainer } from 'components/PageContainer'
import { SalesService } from 'lib/api'
import { useResErrors } from 'hooks'
import CustomScatterChart from './chart/CustomScatterChart'

const useStyles = makeStyles(theme => ({
  rootDiv: {
    position: 'relative',
    display: 'flex'
  },
  scatterChartLegendContainer: {
    display: 'flex',
    gap: 12
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 12,
    marginBottom: 6
  },
  legendLabel: {
    color: GRAY_COLORS[600],
    fontWeight: theme.typography.fontWeightLight
  }
}))

export default function PriceGraphicsModal({ open, car, onClose }) {
  const [loading, setLoading] = useState(true)
  const [kolesaData, setKolesaData] = useState([])

  const { standardCheck } = useResErrors()

  const classes = useStyles()

  useEffect(() => {
    async function getKolesaData() {
      const filter = {
        brand: car?.marka.name,
        model: car?.model.name,
        city: car?.branch.city,
        year_start: car?.year,
        year_finish: car?.year,
        engine_type: car?.engineType.name === 'Бензиновый' ? 'Бензин' : 'Дизель'
        // transmission: ,
        // engine_capacity: car?.engine_capacity,
        // car_dwheel: car?.dwheelType.name
      }

      const response = await SalesService.getPriceStatistics(filter)

      standardCheck(
        response,
        () => {
          setKolesaData(response.data.kolesaAdsList)
          setLoading(false)
        },
        { textErr: 'Ошибка загрузки данных' }
      )
    }

    getKolesaData()
  }, [])

  function handleClose() {
    onClose()
  }

  return (
    <Modal
      fullScreen
      aria-labelledby="show-work-list-title"
      open={open}
      onClose={handleClose}
    >
      <PageContainer
        customHeader={
          <HeaderBack onClick={handleClose}>
            Сравнение цен авто на рынке
          </HeaderBack>
        }
      >
        <Box className={classes.scatterChartLegendContainer}>
          <Box className={classes.legend}>
            <Dot color={PRIMARY_COLORS[600]} />

            <Typography className={classes.legendLabel}>Мое авто</Typography>
          </Box>

          <Box className={classes.legend}>
            <Dot color={PRIMARY_COLORS[300]} />

            <Typography className={classes.legendLabel}>
              Авто на рынке
            </Typography>
          </Box>
        </Box>

        <CustomScatterChart data={car} kolesaData={kolesaData} />

        <LoaderBackdrop loading={loading} />
      </PageContainer>
    </Modal>
  )
}
